import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { BlockUIModule } from 'ng-block-ui';
import { OjeuTitleComponent } from './ojeu/section.title.component';
import { HvtS1Component } from './ojeu/hvt.section.1.component';
import { HvtSection1ContactComponent } from './ojeu/hvt.section.1.contact.component';
import { HvtS2Component } from './ojeu/hvt.section.2.component';
import { HvtS3Component } from './ojeu/hvt.section.3.component';
import { HvtS4Component } from './ojeu/hvt.section.4.component';
import { HvtS5Component } from './ojeu/hvt.section.5.component';
import { HvtSection5ContactComponent } from './ojeu/hvt.section.5.contact.component';
import { HvtS6Component } from './ojeu/hvt.section.6.component';
import { HvtSection6ContactComponent } from './ojeu/hvt.section.6.contact.component';
import {HttpPrefixPipeModule} from '../../components/pipes/httpprefix.pipe/http.prefix.pipe.module';

@NgModule({
    declarations: [HvtS1Component, HvtSection1ContactComponent, HvtS2Component, HvtS3Component, HvtS4Component, OjeuTitleComponent, HvtS5Component, HvtSection5ContactComponent, HvtS6Component, HvtSection6ContactComponent],
    imports: [BrowserModule, FormsModule, PagingModule, RouterModule, TooltipModule, BlockUIModule, HttpPrefixPipeModule],
    exports: [HvtS1Component, HvtS2Component, HvtS3Component, HvtS4Component, HvtS5Component, HvtS6Component]
})

export class NoticesModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/notices.module.ts